var React = require('react');

function RecycleInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11.4999 1.97725C8.22752 1.97725 5.56812 4.63665 5.56812 7.90899H8.53399L4.5795 11.8635L0.625 7.90899H3.59087C3.59087 3.53927 7.13015 0 11.4999 0C13.052 0 14.4954 0.454767 15.7114 1.22589L14.268 2.66929C13.4475 2.2244 12.4984 1.97725 11.4999 1.97725ZM14.4662 7.90965L18.4207 3.95515L22.3752 7.90965H19.4094C19.4094 12.2794 15.8701 15.8186 11.5004 15.8186C9.94823 15.8186 8.50484 15.3639 7.28883 14.5927L8.73222 13.1494C9.55278 13.5942 10.5019 13.8414 11.5004 13.8414C14.7727 13.8414 17.4321 11.182 17.4321 7.90965H14.4662Z","fill":"#78781F"}));
}

RecycleInline.defaultProps = {"width":"23","height":"16","viewBox":"0 0 23 16","fill":"none"};

module.exports = RecycleInline;

RecycleInline.default = RecycleInline;
